import React from 'react';
import PropTypes from 'prop-types';

const ItemCard = ({ title, imageUrl, onSelect, buttonText, features }) => {
  return (
    <div className="item-card">
      <div className="item-card_top">
        {imageUrl && <img src={imageUrl} alt="" className="item-card_img" />}
      </div>
      {onSelect && (
        <div className="item-card_bottom">
          <div className="item-card_text">
            {title && <h1 className="item-card_title">{title}</h1>}
            {features.map(feat => (
              <div className="item-card_inner">
                <div className="item-card_inner_left">
                  <img
                    src={feat.thumbnail}
                    alt=""
                    className="item-card_inner_img"
                  />
                </div>
                <div className="item-card_inner_right">
                  <div className="item-card_inner_title">{feat.title}</div>
                  <div className="item-card_inner_desc">{feat.subTitle}</div>
                </div>
              </div>
            ))}
          </div>
          <button className="item-card_btn" onClick={onSelect}>
            {buttonText}
          </button>
        </div>
      )}
    </div>
  );
};

ItemCard.propTypes = {
  title: PropTypes.string,
  imageUrl: PropTypes.string,
  buttonText: PropTypes.string,
  onSelect: PropTypes.func
};

ItemCard.defaultProps = {
  buttonText: 'select'
};

export default ItemCard;
